module.exports = __webpack_public_path__ + "static/Universidad-cfa8598571deb81efcb41e91d1680361.jpg";